import React from "react";

import { SEARCH, BROWSE_BY_CAMPAIGN } from "data/links";

import colors from "core/colors";

// for hero:
import heroDesktopImg from "./images/hero-desktop.png";
import heroTabletImg from "./images/hero-tablet.png";
import heroMobileImg from "./images/hero-mobile.png";

export const heroImages = {
    desktop: heroDesktopImg,
    tablet: heroTabletImg,
    mobile: heroMobileImg
};

export const heroHeading =
    "Photos have the power to shape, reinforce, and change our perceptions.";

export const heroSearchPlaceholder = {
    desktop: "Search art-quality photos",
    tablet: "Search art-quality photos",
    mobile: "Search photos"
};

// for "bullets" section:
import Eye from "core/ReusableIcons/Eye";
import Photo from "core/ReusableIcons/Photo";
import Receipt from "core/ReusableIcons/Receipt";

export const bullets = [
    {
        icon: <Eye fillColor={colors.secondary.orca} size="xl" />,
        title: "Mission-Driven Curation",
        text:
            "A growing, professionally selected collection of authentic pictures that celebrate diversity and inclusion."
    },
    {
        icon: <Photo fillColor={colors.secondary.orca} size="xl" />,
        title: "Beautiful & Affordable",
        text:
            "Exceptional images available at price points for any budget, from free photo downloads to high-res jpgs."
    },
    {
        icon: <Receipt fillColor={colors.secondary.orca} size="xl" />,
        title: "Worry-Free Licenses",
        text:
            "Support photographers and have peace of mind with clear image usage rights, including model and property releases."
    }
];

// for "Collections" section:
import StudentsImg from "./images/collections-students.png";
import HikingImg from "./images/collections-hiking.png";
import ProtestsAndActivismImg from "./images/collections-protestsandactivism.png";
import Covid19Img from "./images/collections-covid19.png";
import DiversityInTechImg from "./images/collections-DIT.png";
import FlatLaysImg from "./images/collections-flat-lays.png";

export const collectionsTitle =
    "An inclusive, diverse collection of art-quality photos. Because representation matters.";

export const collections = [
    {
        title: "Diversity in Tech",
        subtitle: null,
        url: BROWSE_BY_CAMPAIGN.replace(
            ":campaignDetail",
            "diversity-in-tech-1"
        ),
        imageSrcAndTitle: {
            imageSrc: DiversityInTechImg,
            title: "Diversity in Tech"
        },
        type: "primary",
        isPhoto: true
    },
    {
        title: "Students",
        subtitle: null,
        url: `${SEARCH}?q=students`,
        imageSrcAndTitle: {
            imageSrc: StudentsImg,
            title: "Students"
        },
        type: "primary",
        isPhoto: true
    },
    {
        title: "Protests and Activism",
        subtitle: null,
        url: `${SEARCH}?q=blm`,
        imageSrcAndTitle: {
            imageSrc: ProtestsAndActivismImg,
            title: "Protests and Activism"
        },
        type: "primary",
        isPhoto: true
    },
    {
        title: "COVID-19",
        subtitle: null,
        url: `${SEARCH}?q=covid`,
        imageSrcAndTitle: {
            imageSrc: Covid19Img,
            title: "COVID-19"
        },
        type: "primary",
        isPhoto: true
    },
    {
        title: "Hiking",
        subtitle: null,
        url: `${SEARCH}?q=hiking`,
        imageSrcAndTitle: {
            imageSrc: HikingImg,
            title: "Hiking"
        },
        type: "primary",
        isPhoto: true
    },
    {
        title: "Flat Lays",
        subtitle: null,
        url: `${SEARCH}?q=flat+lay`,
        imageSrcAndTitle: {
            imageSrc: FlatLaysImg,
            title: "Flat Lays"
        },
        type: "primary",
        isPhoto: true
    }
];

export const pillsTitle = "Explore Trends";

export const pills = [
    {
        title: "Entrepreneur",
        url: `${SEARCH}?q=entrepreneur`
    },
    {
        title: "Food",
        url: `${SEARCH}?q=food`
    },
    {
        title: "Leadership",
        url: `${SEARCH}?q=leadership`
    },
    {
        title: "People",
        url: `${SEARCH}?q=people`
    },
    {
        title: "Copy Space",
        url: `${SEARCH}?q=copy-space`
    },
    {
        title: "Idea",
        url: `${SEARCH}?q=idea`
    },
    {
        title: "Business",
        url: `${SEARCH}?q=business`
    },
    {
        title: "Happy",
        url: `${SEARCH}?q=happy`
    }
];

// Photography Features section:
import Featured1 from "./images/photographer-avel-shah.png";
import Featured2 from "./images/photographer-alia-youssef.png";
import Featured3 from "./images/photographer-introducing-noun-photos.png";

export const featuredTitle = "Photography Features";

export const features = [
    {
        title: "Photographer Feature: Avel Shah",
        category: "Spotlight",
        imgSrc: Featured1,
        url:
            "https://blog.thenounproject.com/photographer-avel-shah-744263538e37",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Photographer Feature: Alia Youssef",
        category: "Spotlight",
        imgSrc: Featured2,
        url:
            "https://blog.thenounproject.com/photographer-alia-youssef-72f35bc66b23",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Introducing Noun Project Photos",
        category: "Photos",
        imgSrc: Featured3,
        url:
            "https://blog.thenounproject.com/introducing-noun-project-photos-35d92bc95ab7",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];
